export const stripeConnectInstructionLink =
  'https://support.stripe.com/questions/getting-started-with-stripe-through-a-third-party-platform';

export const stripeTermsOfUseLink = 'https://stripe.com/legal/consumer';

export const stripePrivacyPolicyLink = 'https://stripe.com/privacy';
